<div class="container pt-2">
    <section class="pt-5">
        <h2 class="text-center mt-5 mb-5"><strong>Features of Nepal Property</strong></h2>
        <ngx-slick-carousel class="carousel" 
                #slickModal="slick-carousel" 
                [config]="slideConfig" >
            <div ngxSlickItem *ngFor="let slide of slides" class="slide">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="{{ slide.img }}">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            {{ slide.title }}
                        </p>
                        <p class="text-small">{{ slide.text }}</p>
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
    </section>
</div>